<template >
<div id="pdf">
  <!-- <v-bottom-navigation
    background-color="blue"
    color="white"
    horizontal
  >
    <v-btn>
      <span>Productos</span>

      <v-icon>mdi-package-variant-closed</v-icon>
    </v-btn>

    <v-btn to="/almacen">
      <span>Bodegas</span>

      <v-icon>mdi-hexagon-slice-6</v-icon>
    </v-btn>

    <v-btn>
      <span>Movimientos</span>

      <v-icon>mdi-file-replace-outline</v-icon>
    </v-btn>
  </v-bottom-navigation> -->

  <v-data-table
    :headers="headers"
    :items="getAllItems"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top >
      <v-toolbar flat color="white" >
        <v-toolbar-title>PRODUCTOS</v-toolbar-title> 
        
        <v-divider class="mx-4" inset  vertical ></v-divider>
        <v-text-field
              v-model="search"
              type="text"
              append-icon="mdi-magnify"
              label="Buscar por producto..."
              single-line
              hide-details
              class="mr-3"
          ></v-text-field> 
        <v-btn color="green" small outlined @click="descargarExcel"><v-icon color="green">mdi-microsoft-excel</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-divider class="mx-4" inset  vertical ></v-divider>
        <!-- <v-btn  color="teal"  dark class="mb-2" to="/almacen">Mobile</v-btn> -->
        <v-dialog v-model="dialog" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn  color="primary"  dark class="mb-2" v-bind="attrs" v-on="on">+ Nuevo</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
              <v-spacer></v-spacer>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="8" md="8">
                    <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.codigo" label="Codigo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.ubicacion" label="Ubicacion" type="text"></v-text-field>
                  </v-col>  
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.preciocompra" label="Precio Compra" prefix="Q "></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.preciominimo" label="Precio Minimo" prefix="Q "></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.preciosugerido" label="Precio Sugerido" prefix="Q "></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.stockminimo" label="Stock Minimo" type="number"></v-text-field>
                  </v-col> 
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.stockactual" label="Stock Actual" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea outlined v-model="editedItem.descripcion" label="Descripcion"></v-textarea>
                  </v-col>                 
                            
                </v-row>
                <v-row>
                    <v-autocomplete  v-model="editedItem.idcategoria" :items="getCategoriasActivas" outlined  clearable hide-selected item-text="nombre" item-value="idcategoria" label="Seleccione Categoria" >
                      </v-autocomplete>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.tipo`]="{ item }">
      <p v-text="item.tipo"></p>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="editItem(item)"  v-if="item.estado == 'Activo'" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item.idarticulo)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>
  </div>
</template>

<script>
import {json2excel} from 'js2excel';
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
     name:'Productos',  
     data: () => ({
      search:'',
      nombreproducto:'',
      dialog: false,
      itemstipo:["Bien","Servicio"],
      itemscategorias:[],
      editedIndex: -1,
      editedItem: {
        codigo: '',
        nombre: '',
        ubicacion: '',
        descripcion: '',
        preciocompra:1,
        preciosugerido:1,
        preciominimo:1,
        stockminimo: 1,
        stockactual: 1,
        tipo:'B',
        idcategoria: 1,
      },
      defaultItem: {
        codigo: '',
        nombre: '',
        ubicacion: '',
        descripcion: '',
        preciocompra:1,
        preciosugerido:1,
        preciominimo:1,
        stockminimo: 1,
        stockactual: 1,
        tipo:'B',
        idcategoria: 1
      },
      headers:[
        { text: 'Cod.', align: ' d-none d-sm-table-cell' , value: 'codigo' },
        { text: 'Nombre', value: 'nombre',width: '50%'},
        { text: 'Stock Minimo',align: 'center', value: 'stockminimo' },
        { text: 'Stock Actual',align: 'center', value: 'stockactual' },
        { text: 'Precio Compra',align: 'center', value: 'preciocompra' },
        { text: 'Precio Sugerido',align: 'center', value: 'preciosugerido' },
        { text: 'Precio Minimo',align: 'center', value: 'preciominimo'},
        { text: 'Actions',align: 'center', value: 'actions', sortable: false },
        ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Registro' : 'Editar Registro'
      },
      getAllItems(){
        return this.$store.getters.getAllProductos
      },
      getCategoriasActivas(){
        return this.$store.getters.getCategoriasActivas
      },
      getTokenUser(){
        return this.$store.getters.getTokenUser
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    async created () {
      await this.initialize()
    },

    methods: {  
      async initialize () {
        await this.$store.dispatch('setAllCategorias')   
        await this.$store.dispatch('setProductos')      
      },
      parsedata(){      
        this.editedItem.preciocompra=parseFloat(this.editedItem.preciocompra)
        this.editedItem.preciosugerido=parseFloat(this.editedItem.preciosugerido)
        this.editedItem.preciominimo=parseFloat(this.editedItem.preciominimo)
        this.editedItem.stockminimo=parseInt(this.editedItem.stockminimo)
        this.editedItem.stockactual=parseInt(this.editedItem.stockactual)

        this.editedItem.idcategoria=parseInt(this.editedItem.idcategoria)
        
      },
      editItem (item) {
        this.editedIndex = this.getAllItems.indexOf(item);
        this.editedItem = Object.assign({}, item)

        this.editedItem.idcategoria=parseInt(this.editedItem.idcategoria.idcategoria)
        this.dialog = true
        this.parsedata() 
        
      },
      deleteItem (idarticulo) {
        
        Swal.fire({
          title: 'Esta Seguro?',
          text: "El registro será Desactivado!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Desactivar!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {
            //Procedimiento para eliminarlo
            this.cambiarestado("Eliminado",idarticulo)
          }
        })
       
              
      },
      cambiarestado(estado,idarticulo) {
        axios.put(`${this.$store.state.urlapi}/articulos/${idarticulo}`,{estado:estado},this.getTokenUser)
          .then(() => {
            this.alertDone();
            this.initialize();
          });
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.parsedata()
        if (this.editedIndex > -1) {       
          this.putItem()
        } else {
          this.postItem()
        }
        this.close()
      },
      postItem(){
        axios.post(`${this.$store.state.urlapi}/articulos`,this.editedItem,this.getTokenUser).then(()=>{                
          this.alertDone()
          this.initialize()          
        }).catch(err=> {this.alertError(), console.log(err)})
      },
      putItem(){     
       axios.put(`${this.$store.state.urlapi}/articulos/${this.editedItem.idarticulo}`,this.editedItem,this.getTokenUser).then(()=>{         
          this.alertDone()
          this.initialize()          
        })
        
      },
      print(){
        window.open("/reportes/inventarioprod.php","blank")
      },
      descargarExcel(){
        const elementos = []
        this.getAllItems.map(function(item) {         
          item.preciocompra = parseFloat(item.preciocompra)
          item.preciosugerido = parseFloat(item.preciosugerido)
          item.preciominimo = parseFloat(item.preciominimo)
          item.stockminimo = parseFloat(item.stockminimo)
          item.stockactual = parseFloat(item.stockactual)
          elementos.push(item)
        })

        const data = elementos
        try {
            json2excel({
                data,
                name: 'Inventario_Productos',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      //Notificaciones Swal
      alertDone(){
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
      },
      alertError(){
        Swal.fire({
          icon: 'error',
          title: 'No pudo realizarse la solicitud',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    
}
</script>
<style lang="css">
.v-data-table td{
  font-size: 12px !important;
  height: 35px !important;
}

</style>
